import { compose } from 'recompose'

import { connect } from 'react-redux';
import { listar } from '../../actions'

import { withRouter } from 'react-router-dom';
const mapStateToProps = ({ PerfisAdminReducer }, props) => {

    return { loading: PerfisAdminReducer.rLista.loading, lista: PerfisAdminReducer.rLista.lista };
};



export default compose(
    withRouter,
    connect(mapStateToProps, { listar })
)


// WEBPACK FOOTER //
// ./src/routes/admin/ConsultaPerfisAdmin/componentes/ConsultaPerfisAdmin/ConsultaPerfisAdmin.enhancer.js